import React, { Fragment } from 'react';
import DashboardPanelChildLogins from "root/dashboard/DashboardPanelChildLogins";
import DashboardPanelChildPostsSent from "root/dashboard/DashboardPanelChildPostsSent";
import DashboardPanelChildMessagesSent from "root/dashboard/DashboardPanelChildMessagesSent";
import DashboardPanelChildPostsReceived from "root/dashboard/DashboardPanelChildPostsReceived";
import DashboardPanelChildDiary from "root/dashboard/DashboardPanelChildDiary";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {UserTypes} from "root/DataFunctions/Constants";

const DashboardUserSummary = (props) =>
{
    const {search} = useLocation();
    const queryParams = queryString.parse(search);
    const user_type= queryParams.userType;

    return (
        <Fragment>
            <div className='row'>
                <div className='col-md-12'>
                    <DashboardPanelChildLogins child_uid={props.user_id} title={'Logins'} year={props.year} month={props.month+1}/>
                </div>
            </div>

            <div className='row'>
                <div className='col-md-12'>
                    <DashboardPanelChildPostsSent child_uid={props.user_id} title={'Posts Sent'} year={props.year} month={props.month+1}/>
                </div>
            </div>

            <div className='row'>
                <div className='col-md-12'>
                    <DashboardPanelChildMessagesSent child_uid={props.user_id} title={'Messages Sent'} year={props.year} month={props.month+1}/>
                </div>
            </div>

            { +user_type === UserTypes.CHILD &&
                <div className='row'>
                    <div className='col-md-12'>
                        <DashboardPanelChildPostsReceived child_uid={props.user_id} title={'Posts Recieved'} year={props.year} month={props.month+1}/>
                    </div>
                </div>
            }

            { +user_type === UserTypes.CHILD &&
                <div className='row'>
                    <div className='col-md-12'>
                        <DashboardPanelChildDiary child_uid={props.user_id} title={'Diary Entries'} year={props.year} month={props.month+1}/>
                    </div>
                </div>
            }
        </Fragment>
    )
};

export default DashboardUserSummary ;

